<template>
    <header :class="this.currentMode" ref="header">
        <div class="header-wrap">
            <div class="header-col logo-area">
                <router-link to="/">
                    <div class="logo-box">
                        <img v-if="this.currentMode === ''" src="@/assets/KICC_CI_en_white.svg" alt="" />
                        <img v-else src="@/assets/KICC_CI_en_color.svg" alt="" />
                    </div>
                </router-link>
            </div>
            <div class="header-col nav-area" ref="header_nav">
                <ul>
                    <li v-for="siteMenu in siteMenus" :key="siteMenu.key">
                        <a>{{ siteMenu[$t('common.name')] }}</a>
                        <ul class="sub_menu" v-if="siteMenu.subMenus">
                            <li v-for="subMenu of siteMenu.subMenus" :key="subMenu.key">
                                <span v-if="!subMenu.link && subMenu.subMenus.length > 0" class="fold_menu" @click="toggleSubMenu">
                                    {{ subMenu[$t('common.name')] }}
                                    <i v-if="subMenu.subMenus.length > 0">
                                        <img src="@/assets/nav_arrow.png" alt="" />
                                    </i>
                                </span>
                                <ul v-if="!subMenu.link && subMenu.subMenus.length > 0">
                                    <li v-for="subMenu2 of subMenu.subMenus" :key="subMenu2.key">
                                        <router-link :to="subMenu2.link" :disabled="subMenu2.disabled">
                                            {{ subMenu2[$t('common.name')] }}
                                        </router-link>
                                    </li>
                                </ul>
                                <template v-else-if="subMenu.link">
                                    <a
                                        v-if="subMenu.key === 'internet_cash_receipt'"
                                        :href="subMenu.link.startsWith('http') ? subMenu.link : `https://${subMenu.link}`"
                                        target="_blank"
                                    >
                                        {{ subMenu[$t('common.name')] }}
                                        <i class="ico_outbound"></i>
                                    </a>
                                    <router-link v-else :disabled="subMenu.disabled" :to="subMenu.link">
                                        {{ subMenu[$t('common.name')] }}
                                    </router-link>
                                </template>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="header-col menu-area">
                <!-- <button class="lang_btn" @click="changeLanguage">
                    <i class="icon">
                        <img v-if="this.currentMode === ''" src="@/assets/ic_lang_white.png" alt="" />
                        <img v-else src="@/assets/ic_lang_black.png" alt="" />
                    </i>
                    <span>{{ $t('common.lang') }}</span>
                </button> -->
                <button class="menu_btn" @click="toggleFullMenu">
                    <i class="icon">
                        <img v-if="this.currentMode === ''" src="@/assets/ic_menu_white.png" alt="" />
                        <img v-else src="@/assets/ic_menu_black.png" alt="" />
                    </i>
                </button>
            </div>
        </div>
        <div class="header_back"></div>
    </header>

    <div class="full_site_menu" v-show="fullmenu">
        <button class="full_close" @click="toggleFullMenu"></button>
        <ul>
            <li v-for="siteMenu in siteMenus" :key="siteMenu.key">
                <p>{{ siteMenu[$t('common.name')] }}</p>
                <ul class="sub_menu" v-if="siteMenu.subMenus">
                    <li v-for="subMenu of siteMenu.subMenus" :key="subMenu.key">
                        <router-link v-if="subMenu.link && subMenu.key !== 'internet_cash_receipt'" :disabled="subMenu.disabled" :to="subMenu.link">
                            {{ subMenu[$t('common.name')] }}
                        </router-link>
                        <a
                            v-else-if="subMenu.key === 'internet_cash_receipt'"
                            :href="subMenu.link.startsWith('http') ? subMenu.link : `https://${subMenu.link}`"
                            target="_blank"
                        >
                            {{ subMenu[$t('common.name')] }}
                            <i class="ico_outbound"></i>
                        </a>
                        <span v-else>
                            {{ subMenu[$t('common.name')] }}
                            <i class="fold_button"><img src="@/assets/list_dropdown_icon.png" alt="" /></i>
                        </span>
                        <ul v-if="!subMenu.link && subMenu.subMenus.length > 0">
                            <li v-for="subMenu2 of subMenu.subMenus" :key="subMenu2.key">
                                <a
                                    v-if="subMenu2.key === 'internet_cash_receipt'"
                                    :href="subMenu2.link.startsWith('http') ? subMenu2.link : `https://${subMenu2.link}`"
                                    target="_blank"
                                >
                                    {{ subMenu2[$t('common.name')] }}
                                    <i class="ico_outbound"></i>
                                </a>
                                <router-link v-else :to="subMenu2.link" :disabled="subMenu2.disabled">
                                    {{ subMenu2[$t('common.name')] }}
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>
<script>
import siteMenus from '@/data/sitemap.json';

export default {
    props: {
        mode: {
            default: '',
        },
    },
    data() {
        return {
            siteMenus: siteMenus,
            fullmenu: false,
            currentMode: this.mode,
            headerAnimationDelay: 200,
        };
    },
    mounted() {
        if (this.$route.name === 'apply') {
            this.currentMode = 'relative white';
            return;
        }

        if (this.$route.name === 'main') {
            this.currentMode = 'main white';
        }

        if (
            this.$route.name === 'privacy' ||
            this.$route.name === 'guide' ||
            this.$route.name === 'digital' ||
            this.$route.name === 'employmentretrieve' ||
            this.$route.name === 'employmentretrievelist'
        ) {
            this.currentMode = 'etc white';
        }

        this.$refs.header.querySelectorAll('.fold_menu + ul').forEach((el) => (el.style.maxHeight = '0px'));

        window.addEventListener('mousemove', ({ clientY }) => {
            if (clientY <= 80) {
                this.onMouseHeader();
            }
        });
        this.clickControl();
        this.$lenis.on('scroll', this.handleScroll);
        this.$refs.header_nav.addEventListener('mouseover', this.onMouseHeaderNav);
        this.$refs.header.addEventListener('mouseover', this.onMouseHeader);
        this.$refs.header.addEventListener('mouseleave', this.leaveMouseHeader);

        document.querySelector('.full_site_menu > ul').addEventListener('wheel', function (event) {
            event.preventDefault();
            this.scrollTop += event.deltaY;
        });

        document.querySelector('.full_site_menu > ul').addEventListener(
            'touchmove',
            function (event) {
                event.stopPropagation();
            },
            { passive: false }
        );
    },
    beforeUnmount() {
        document.body.style.overflow = '';
        clearTimeout(this.timeout);

        this.$refs.header.removeEventListener('mouseleave', this.leaveMouse);
        this.$refs.header_nav.removeEventListener('mouseover', this.onMouseHeaderNav);
    },
    methods: {
        changeLanguage() {
            alert('준비 중입니다.');
            // this.$i18n.locale = this.$i18n.locale === 'ko' ? 'en' : 'ko';
        },
        toggleFullMenu() {
            this.fullmenu = !this.fullmenu;
        },
        onMouseHeader() {
            if (this.currentMode !== 'white') {
                this.currentMode = 'white';
                this.showHeader();
            }
        },
        clickControl() {
            document.querySelectorAll('.full_site_menu > ul p').forEach((el, idx) => {
                el.addEventListener('click', () => {
                    if (el.nextElementSibling) {
                        document.querySelectorAll('.full_site_menu > ul p').forEach((el, idx2) => {
                            if (idx !== idx2) {
                                el.nextElementSibling.classList.remove('sub_fold');
                                // el.nextElementSibling.style.display = 'none';
                                el.nextElementSibling.querySelectorAll('li').forEach((el) => {
                                    if (el.querySelector('ul')) {
                                        // el.querySelector('ul').style.display = 'none';
                                        el.querySelector('ul').classList.remove('sub_fold');
                                    }
                                });
                            }
                        });
                        // el.nextElementSibling.style.display = el.nextElementSibling.style.display === 'flex' ? 'none' : 'flex';
                        el.nextElementSibling.classList.toggle('sub_fold');
                    }
                });
            });

            document.querySelectorAll('.full_site_menu .sub_menu > li > span').forEach((el, idx) => {
                el.addEventListener('click', () => {
                    if (el.nextElementSibling) {
                        document.querySelectorAll('.full_site_menu .sub_menu > li > span').forEach((el, idx2) => {
                            if (idx !== idx2) {
                                el.nextElementSibling.classList.remove('sub_fold');
                                // el.nextElementSibling.style.display = 'none';
                            }
                        });
                        // el.nextElementSibling.style.display = el.nextElementSibling.style.display === 'flex' ? 'none' : 'flex';
                        el.nextElementSibling.classList.toggle('sub_fold');
                    }
                });
            });
        },
        leaveMouseHeader() {
            if (this.currentMode === 'white') {
                if (window.scrollY <= 490) {
                    if (this.$route.name === 'main') {
                        if (window.scrollY === 0) {
                            this.currentMode = 'main white';
                        } else {
                            this.currentMode = 'white';
                        }
                    } else if (
                        this.$route.name === 'privacy' ||
                        this.$route.name === 'guide' ||
                        this.$route.name === 'digital' ||
                        this.$route.name === 'employmentretrieve' ||
                        this.$route.name === 'employmentretrievelist'
                    ) {
                        if (window.scrollY === 0) {
                            this.currentMode = 'etc white';
                        } else {
                            this.currentMode = 'white';
                        }
                    } else {
                        this.currentMode = '';
                    }
                }
            }
            this.$refs.header.classList.remove('fold');
            this.$refs.header.querySelector('.header_back').style.height = 0;
        },
        onMouseHeaderNav() {
            if (!this.$refs.header.classList.contains('fold')) {
                this.$refs.header.querySelector('.header_back').style.height = this.setHeaderBackHegiht();
            }
            this.$refs.header.classList.add('fold');
        },
        async handleScroll() {
            const currentScrollTop = this.$lenis.scroll;

            if (this.$lenis.direction < 0) {
                this.showHeader();
                this.currentMode = 'white';

                if (currentScrollTop <= 80) {
                    if (this.$route.name !== 'main') {
                        this.currentMode = '';
                    }
                    this.showHeader();
                }
            } else {
                if (currentScrollTop > 490) {
                    await this.hideHeader();
                    if (this.$route.name !== 'main') {
                        this.currentMode = '';
                    }
                }
            }

            if (this.$route.name === 'main') {
                if (Math.floor(currentScrollTop) > 0) {
                    this.currentMode = ['white'];
                } else {
                    this.currentMode = 'main white';
                }
            }

            if (
                this.$route.name === 'privacy' ||
                this.$route.name === 'guide' ||
                this.$route.name === 'digital' ||
                this.$route.name === 'employmentretrieve' ||
                this.$route.name === 'employmentretrievelist'
            ) {
                if (currentScrollTop > 0) {
                    this.currentMode = ['white'];
                } else {
                    this.currentMode = 'etc white';
                }
            }

            this.lastScrollTop = currentScrollTop;
        },
        showHeader() {
            if (this.$route.name === 'main') return;
            if (this.$refs.header) this.$refs.header.style.transform = 'translate(-50%, 0)';
        },
        hideHeader() {
            if (this.$route.name === 'main') return;
            if (this.$refs.header) {
                this.$refs.header.style.transform = 'translate(-50%,-100%)';
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve();
                    }, this.headerAnimationDelay);
                });
            }
        },
        closeAllSubMenu() {
            this.$refs.header.querySelectorAll('.fold_menu').forEach((el) => {
                el.classList.remove('open');
                el.nextElementSibling.style.maxHeight = '0px';
            });
        },
        async toggleSubMenu({ target }) {
            target = target.closest('.fold_menu');

            if (!target.classList.contains('open')) {
                this.closeAllSubMenu();
            }
            target.classList.toggle('open');
            if (target.classList.contains('open')) {
                target.nextElementSibling.style.maxHeight = `${target.nextElementSibling.scrollHeight}px`;
            } else {
                target.nextElementSibling.style.maxHeight = '0px';
            }
            this.$refs.header.querySelector('.header_back').style.height = this.setHeaderBackHegiht();
        },

        setHeaderBackHegiht() {
            const result = Math.max(...[...this.$refs.header.querySelectorAll('.sub_menu')].map((el) => el.scrollHeight), 510) + 30;
            return result < window.innerHeight ? `${result}px` : window.innerHeight;
        },
    },
    watch: {
        fullmenu: function () {
            if (this.fullmenu === true) {
                this.$lenis.stop();
                document.body.style.overflow = 'hidden';
            } else {
                this.$lenis.start();
                document.body.style.overflow = '';
            }
        },
    },
};
</script>
<style lang="scss" scoped>
header {
    transition: transform 0.3s ease-in-out, top 0.3s ease-in-out, max-width 0.3s ease-in-out;
    position: absolute;
    z-index: 1001;
    border-bottom: 1px solid transparent;
    width: 100%;
    max-width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    overflow: hidden;

    @media screen and (max-width: 768px) {
        height: 70px;
    }

    &.relative {
        position: relative !important;
        .nav-area {
            display: none !important;
        }
        .lang_btn {
            display: none !important;
        }
    }

    &.main {
        top: 30px;
        border-radius: 10px;
        width: 100%;
        max-width: 1860px;

        @media screen and (max-width: 1600px) {
            max-width: 90%;
        }
    }

    &.white {
        position: fixed;
        background: #fff;
        border-bottom: 1px solid var(--border-color2);

        &.fold {
            overflow: visible;

            .header_back {
                border-bottom: 1px solid var(--border-color2);
                background: var(--white);
            }

            .header-wrap {
                .nav-area ul {
                    z-index: 1;
                    gap: 120px;

                    li {
                        width: auto;
                        padding-bottom: 1px;
                    }

                    .sub_menu {
                        top: 100%;
                        gap: 0;
                        bottom: auto;
                        opacity: 1;
                        width: auto;

                        li {
                            white-space: nowrap;
                        }
                    }
                }
            }
        }

        .header-wrap {
            .nav-area ul li a {
                color: var(--black1);
            }

            .menu-area .lang_btn span {
                color: var(--black1) !important;
            }
        }

        a[disabled],
        span[disabled] {
            opacity: 0.3;
        }
    }

    &.etc {
        border-bottom: 1px solid transparent;
    }

    .header_back {
        background: var(--white);
        width: 100%;
        height: 0;
        position: absolute;
        top: calc(100% + 1px);
        z-index: 0;
        /* transition: height 0.2s ease-in-out; */
        overflow: hidden;
    }

    .header-wrap {
        width: 100%;
        max-width: 1920px;
        height: 100%;
        padding: 0 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo-area {
            .logo-box {
                width: 103px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 100%;
                    max-width: 100%;
                }
            }

            a {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .nav-area {
            height: 100%;

            > ul {
                cursor: pointer;
            }

            > ul > li {
                &::after {
                    content: '';
                    position: absolute;
                    width: 0%;
                    left: 50%;
                    transform: translate(-50%, 0);
                    height: 2px;
                    bottom: 0;
                    transition: 0.3s;
                    background: var(--black1);
                }

                &:hover {
                    &::after {
                        width: 100%;
                    }
                }
            }

            ul {
                display: flex;
                height: 100%;
                transition: 0.4s ease-in-out;
                gap: 90px;

                li {
                    list-style: none;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;

                    a,
                    span {
                        display: block;
                        font-weight: 700;
                        font-size: 17px;
                        color: #fff;
                        letter-spacing: -0.025em;
                        white-space: nowrap;
                    }

                    .sub_menu {
                        /* transition-delay: 0.2s; */
                        top: auto;
                        bottom: 100%;
                        position: absolute;
                        display: flex;
                        flex-direction: column;
                        padding-top: 30px;
                        height: auto;
                        gap: 0;
                        opacity: 0;

                        > li {
                            flex-direction: column;

                            a {
                                display: flex;
                                align-items: center;
                                &:hover {
                                    text-decoration: underline !important;
                                }
                                i.ico_outbound {
                                    display: inline-block;
                                    width: 12px;
                                    height: 12px;
                                    margin-left: 5px;
                                    background-position: center;
                                    background-size: 100%;
                                    background-repeat: no-repeat;
                                    background-image: url(@/assets/ic_outbound.png);
                                    filter: brightness(0);
                                }
                            }

                            a,
                            span {
                                color: var(--black1);
                                font-size: 17px;
                                font-weight: 500;
                                letter-spacing: -0.025em;
                                font-family: 'Pretendard', sans-serif;
                                text-underline-offset: 4px;
                            }

                            & + li {
                                margin-top: 25px;
                            }

                            .fold_menu {
                                cursor: pointer;
                                display: flex;
                                gap: 5px;
                                align-items: center;

                                img {
                                    transition: 0.4s ease-in-out;
                                    transform: rotate(180deg);
                                }

                                &.open {
                                    color: var(--red);

                                    img {
                                        transform: none;
                                    }

                                    + ul {
                                        margin-top: 20px;
                                    }
                                }

                                i {
                                    width: 16px;
                                    height: 16px;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }
                            }

                            > ul {
                                transition: none;
                                overflow: hidden;
                                display: flex;
                                flex-direction: column;
                                gap: 20px !important;

                                > li {
                                    > a {
                                        display: flex;
                                        align-items: center;
                                        color: #666;
                                        font-size: 15px;
                                        font-weight: 400;

                                        i.ico_outbound {
                                            display: inline-block;
                                            width: 15px;
                                            height: 15px;
                                            margin-left: 5px;
                                            background-position: center;
                                            background-size: auto;
                                            background-repeat: no-repeat;
                                            background-image: url(@/assets/ic_outbound2.png);
                                        }
                                    }

                                    & + li {
                                        margin-top: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .menu-area {
            display: flex;
            gap: 30px;

            @media screen and (max-width: 768px) {
                gap: 10px;
            }

            button {
                display: flex;
                align-items: center;
                gap: 10px;
                cursor: pointer;
            }

            .lang_btn {
                padding: 0 10px;

                span {
                    letter-spacing: 0.025em;
                    font-size: 17px;
                    font-weight: 700;
                    color: #fff;
                    font-family: 'Play', sans-serif;
                }
            }

            .menu_btn {
                width: 42px;
                height: 42px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }
        }
    }
}

.full_site_menu {
    z-index: 99999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: auto;

    @media screen and (max-width: 1024px) {
        background: rgba(0, 0, 0, 0.7);
    }

    .full_close {
        position: absolute;
        top: 50px;
        right: 50px;
        cursor: pointer;
        width: 30px;
        height: 30px;
        background: url(@/assets/fullmenu_close.png) no-repeat center;

        @media screen and (max-width: 1024px) {
            top: 20px;
            right: 30px;
            z-index: 1000;
        }
    }

    ul {
        li {
            list-style: none;

            p,
            a,
            span {
                color: #fff;
                cursor: pointer;
                display: flex;
                align-items: center;
                i.ico_outbound {
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    margin-left: 5px;
                    background-position: center;
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-image: url(@/assets/ic_outbound-w.png);

                    img {
                      width: 100%;
                    }
                }
            }
        }
    }

    > ul {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;

        @media screen and (max-width: 1024px) {
            overflow-y: auto;
            flex-direction: column;
            padding: 20vmin 10vmin;
            height: 100%;
            justify-content: flex-start;
            gap: 20px;
        }

        > li {
            flex: 0 0 200px;

            @media screen and (max-width: 1024px) {
                flex: 0 0 auto;
            }

            &:hover {
                @media screen and (max-width: 1024px) {
                    p:after {
                        display: none;
                    }
                }

                p {
                    position: relative;

                    &::after {
                        content: '';
                        position: absolute;
                        top: -20px;
                        left: 0;
                        width: 20px;
                        height: 20px;
                        background: url(@/assets/fullmenu_icon.png) no-repeat center / 100%;
                    }
                }
            }

            > p {
                font-size: 30px;
                font-weight: 700;
                margin-bottom: 50px;

                @media screen and (max-width: 1024px) {
                    margin-bottom: 30px;
                }
            }

            > ul {
                display: flex;
                flex-direction: column;
                gap: 20px;

                @media screen and (max-width: 1024px) {
                    display: none;
                    gap: 0;

                    &.sub_fold {
                        display: flex;
                    }
                }

                > li {
                    @media screen and (max-width: 1024px) {
                        margin-bottom: 20px;
                    }

                    .fold_button {
                        img {
                            transform: rotate(0);
                        }
                    }

                    &:has(.sub_fold) {
                        .fold_button {
                            img {
                                transform: rotate(180deg);
                            }
                        }
                    }

                    > span {
                        display: inline-flex;
                        align-items: center;
                        margin-bottom: 10px;
                        opacity: 0.7;

                        .fold_button {
                            display: none;

                            @media screen and (max-width: 1024px) {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 12px;
                                height: 12px;
                                margin-left: 5px;
                                img {
                                    width: 100%;
                                    filter: invert(1);
                                }
                            }
                        }

                        &:hover {
                            opacity: 1;
                        }

                        @media screen and (max-width: 1024px) {
                            margin-bottom: 0;
                        }
                    }

                    > a {
                        opacity: 0.7;

                        &:hover {
                            opacity: 1;
                        }
                    }

                    > ul {
                        padding-left: 20px;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;

                        @media screen and (max-width: 1024px) {
                            display: none;
                            padding-top: 20px;
                            gap: 0;
                            &.sub_fold {
                                display: flex;
                            }
                        }

                        > li {
                            @media screen and (max-width: 1024px) {
                                &:not(:last-child) {
                                    margin-bottom: 15px;
                                }
                            }

                            a {
                                display: flex;
                                align-items: center;
                                opacity: 0.7;

                                i.ico_outbound {
                                    display: inline-block;
                                    width: 15px;
                                    height: 15px;
                                    margin-left: 5px;
                                    background-position: center;
                                    background-size: auto;
                                    background-repeat: no-repeat;
                                    background-image: url(@/assets/ic_outbound-w.png);
                                }

                                &:hover {
                                    opacity: 1;
                                }

                                &::before {
                                    content: '-';
                                    color: #fff;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 1600px) {
    header .header-wrap {
        padding: 0 5%;

        .nav-area ul {
            gap: 64px;
        }
    }

    header.white.fold .header-wrap .nav-area ul {
        gap: 80px;
    }
}

@media screen and (max-width: 1024px) {
    header .header-wrap {
        .nav-area ul {
            display: none;
        }
    }
}
</style>
